import { Container, Link, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import PageHeader from '../../core/components/layout/PageHeader'
import BlockContainer from '../../core/components/layout/BlockContainer'
import { Button } from '../../core/components'
import { useNavigate } from 'react-router-dom'
import { openMailBox } from '../../utils/openMailBox'

function Support() {
    return (
        <Container maxWidth='xl'>
            <Stack spacing={3}>
                {/* <PageHeader title='Questions? Email us at support@mindright.io' description='' /> */}
                <Typography variant='h5' fontWeight={600} gutterBottom>Questions? Email us at  <Link style={{ cursor: 'pointer' }} color='info' onClick={() => openMailBox()} >support@mindright.io</Link></Typography>
                {/* <BlockContainer>
                    <Typography variant='h6' fontWeight={600} fontSize={{xs: 20, md: 24}} gutterBottom>Have Questions? Email Us</Typography>
                    <Typography variant='h6' fontSize={{xs: 16, md: 20}} fontWeight={500} gutterBottom>We’re here to help!</Typography>
                    <Typography variant='body1' gutterBottom>
                        If you have any questions, feedback, or need assistance with anything related to the MindRight, don’t hesitate to reach out. Our team is committed to making sure you have the best experience possible.
                    </Typography>
                    <Typography variant='body1' fontWeight={600} gutterBottom>
                        📧 Email us at: <Link style={{cursor:'pointer'}} color='info' onClick={() => openMailBox()} >support@mindright.io</Link>
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                        We typically respond within 1-2 business days. Whether it’s a technical issue, a feature suggestion, or just a quick question — we’d love to hear from you!
                    </Typography>
                    <Typography variant='body1' gutterBottom>
                        Thank you for being a part of MindRight.
                    </Typography>

                </BlockContainer> */}
            </Stack>
        </Container>
    )
}

export default Support